import HTTP from '@/plugins/axios';

export const professionItems = async(params: any) => {
  const response = await HTTP.get('/jobnews/profession', {
    params,
  });
  return response.data;
};
export const jobListItems = async(params: any) => {
  const response = await HTTP.get('/jobnews/job_list', {
    params,
  });
  return response.data;
};
export const jobListItemsSearch = async(params: any) => {
  const response = await HTTP.get('/jobnews/form_job_list', {
    params,
  });
  return response.data;
};
export const setNotebookApi = async(data: any) => {
  await HTTP.post('/notepad', data);
};
export const deleteNotebookApi = async(id: any) => {
  await HTTP.delete(`/notepad/${id}`);
};
export const professionStateFilter = async(params: any) => {
  const response = await HTTP.get('/jobnews/state_filter', {
    params,
  });
  return response.data;
};
